<script>
import { mapMutations } from 'vuex'
export default {
  name: 'ClassDetailsTab',
  data () {
    return {
      detailsForm: this.$store.state.users.detailsForm,
      suffixOptions: this.$store.state.shared.options.suffixes,
      statusOptions: this.$store.state.shared.options.statuses,
      roleOptions: this.$store.state.shared.options.roles,
      genderOptions: this.$store.state.shared.options.genders,
      stateOptions: this.$store.state.shared.options.states
    }
  },
  computed: {
  },
  methods: {
    ...mapMutations('users', [
      'updateDetailsForm'
    ]),
    ...mapMutations([
      'closeDetails'
    ])
  }
}
</script>

<template>
  <div class="layout-padding fit">
    <div class="q-pb-sm">
      <div class="row">
        <q-field class="q-pa-md col-4">
          <q-input
            float-label="Drivers License Number"
            :value="detailsForm.driversLicenseNumber"
            @keyup.stop="updateDetailsForm({ field: 'driversLicenseNumber', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-4">
          <q-select
            float-label="Role"
            :value="detailsForm.role"
            :options="roleOptions"
            @change="val => updateDetailsForm({ field: 'role', value: val })"
          />
        </q-field>
        <q-field class="q-pa-md col-4">
          <q-select
            float-label="Status"
            :value="detailsForm.status"
            :options="statusOptions"
            @change="val => updateDetailsForm({ field: 'status', value: val })"
          />
        </q-field>
      </div>
    </div>
    <div class="q-py-sm">
      <div class="row">
        <q-field class="q-pa-md col-4">
          <q-input
            float-label="First Name"
            :value="detailsForm.firstName"
            @keyup.stop="updateDetailsForm({ field: 'firstName', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-4">
          <q-input
            float-label="Middle Name"
            :value="detailsForm.middleName"
            @keyup.stop="updateDetailsForm({ field: 'middleName', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-4">
          <q-input
            float-label="Last Name"
            :value="detailsForm.lastName"
            @keyup.stop="updateDetailsForm({ field: 'lastName', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
      </div>
      <div class="row">
        <q-field class="q-pa-md col-2">
           <q-select
            float-label="Suffix"
            :value="detailsForm.suffix"
            :options="suffixOptions"
            @change="val => updateDetailsForm({ field: 'suffix', value: val })"
          />
        </q-field>
        <q-field class="q-pa-md col-4">
          <q-input
            float-label="Social Security Number"
            :value="detailsForm.ssn"
            @keyup.stop="updateDetailsForm({ field: 'ssn', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-3">
          <q-datetime
            type="date"
            float-label="Date of Birth"
            format="MM/D/YYYY"
            :value="detailsForm.dob"
            @input="val => updateDetailsForm({ field: 'dob', value: val })"
            required>
          </q-datetime>
        </q-field>
        <q-field class="q-pa-md col-3">
           <q-select
            float-label="Gender"
            :value="detailsForm.gender"
            :options="genderOptions"
            @change="val => updateDetailsForm({ field: 'gender', value: val })"
          />
        </q-field>
      </div>
      <div class="row">
        <q-field class="q-pa-md col-6">
          <q-input
            float-label="Email"
            :value="detailsForm.email"
            @keyup.stop="updateDetailsForm({ field: 'email', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-6">
          <q-input
            float-label="Phone"
            :value="detailsForm.phone"
            @keyup.stop="updateDetailsForm({ field: 'phone', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
      </div>
    </div>
    <div class="q-py-sm">
      <div class="row">
        <q-field class="q-pa-md col-12">
          <q-input
            float-label="Address 1"
            :value="detailsForm.address1"
            @keyup.stop="updateDetailsForm({ field: 'address1', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
      </div>
      <div class="row">
        <q-field class="q-pa-md col-12">
          <q-input
            float-label="Address 2"
            :value="detailsForm.address2"
            @keyup.stop="updateDetailsForm({ field: 'address2', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
      </div>
      <div class="row">
        <q-field class="q-pa-md col-4">
          <q-input
            float-label="City"
            :value="detailsForm.city"
            @keyup.stop="updateDetailsForm({ field: 'city', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-4">
           <q-select
            float-label="State"
            :value="detailsForm.state"
            :options="stateOptions"
            @change="val => updateDetailsForm({ field: 'state', value: val })"
          />
        </q-field>
        <q-field class="q-pa-md col-4">
          <q-input
            float-label="Zip"
            :value="detailsForm.zip"
            @keyup.stop="updateDetailsForm({ field: 'zip', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
      </div>
    </div>
  </div>
</template>

<style>
</style>
